export class ODataSelect{
    constructor(private select:Array<string>){
        
    }

    public toString():string{
        return this.select.join(",");
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/utility/odata/odata-select.ts